import * as React from 'react';
import {HashRouter, Switch, Route} from 'react-router-dom';

import {Modal} from 'shells/modal/modal';
import {LeftFrame} from 'shells/modal/step-modal/layout';
import {StepList} from 'shells/modal/step-modal/step-list';

import {getMfa} from '../../auth/utils';

import {Done} from './modal/done';
import {RecoveryCodes} from './modal/recovery-codes';
import {SelectMethod} from './modal/select-method';
import {VerifyCode} from './modal/verify-code';
import {VerifySmsPhone} from './modal/verify-sms-phone';
import type {GetMfaApiResponse} from './types';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

const PATH_STEPS = {
    '/connect-mfa/select-method': 0,
    '/connect-mfa/verify-app': 1,
    '/connect-mfa/verify-sms-phone': 1,
    '/connect-mfa/verify-sms': 1,
    '/connect-mfa/app/recovery-codes': 2,
    '/connect-mfa/sms/recovery-codes': 2,
    '/connect-mfa/app/done': 3,
    '/connect-mfa/sms/done': 3,
} as const;

const STEPS = [
    '1. Select a method',
    '2. Verify method',
    '3. Save recovery codes',
    '4. You’re done!',
];

export function ConnectMfaModalRoot(props: Props) {
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [mfaMethod, setMfaMethod] = React.useState<any>(null);

    React.useEffect(() => {
        getMfa().then((result: GetMfaApiResponse) => {
            if (result.result && result.result.type !== null) {
                setMfaMethod(result.result.type);
            }
        });
    }, [mfaMethod, setMfaMethod]);

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            canClickOutsideToClose={false}
            canEscapeToClose={false}
            maxHeight={600}
            noPadding={true}
        >
            <div className='flex full-height'>
                <HashRouter>
                    <LeftFrame
                        title={
                            mfaMethod !== null
                                ? 'Change method of authentication'
                                : 'Enable two-factor authentication'
                        }
                    >
                        <Route
                            render={({location}) => {
                                // @ts-expect-error
                                const activeStep = PATH_STEPS[location.pathname];

                                return (
                                    <>
                                        <StepList activeStepIndex={activeStep} steps={STEPS} />
                                    </>
                                );
                            }}
                        />
                    </LeftFrame>
                    <Switch>
                        <Route
                            path='/connect-mfa/select-method'
                            render={() => (
                                <SelectMethod
                                    resetPhoneNumber={() => {
                                        setPhoneNumber('');
                                    }}
                                />
                            )}
                        />
                        <Route
                            path='/connect-mfa/verify-sms-phone'
                            render={({history}) => (
                                <VerifySmsPhone
                                    history={history}
                                    handlePhoneNumber={setPhoneNumber}
                                    prefilledPhoneNumber={phoneNumber}
                                />
                            )}
                        />
                        <Route
                            path='/connect-mfa/verify-app'
                            render={({history}) => (
                                <VerifyCode
                                    history={history}
                                    method='app'
                                    phoneNumber={phoneNumber}
                                />
                            )}
                        />
                        <Route
                            path='/connect-mfa/verify-sms'
                            render={({history}) => (
                                <VerifyCode
                                    history={history}
                                    method='sms'
                                    phoneNumber={phoneNumber}
                                />
                            )}
                        />
                        <Route
                            path='/connect-mfa/sms/recovery-codes'
                            render={({history}) => <RecoveryCodes history={history} method='sms' />}
                        />
                        <Route
                            path='/connect-mfa/app/recovery-codes'
                            render={({history}) => <RecoveryCodes history={history} method='app' />}
                        />
                        <Route path='/connect-mfa/sms/done' render={() => <Done method='sms' />} />
                        <Route path='/connect-mfa/app/done' render={() => <Done method='app' />} />
                    </Switch>
                </HashRouter>
            </div>
        </Modal>
    );
}
